
import React from 'react'

import Foot from '../common/Foot'
import { Outlet } from 'react-router-dom'
import Header from '../common/Header'


const UserLayout = () => {
 

  return (
    <>
      {/* Header */}
      <Header />

      {/* Main content */}
      <main > 
        <Outlet />
      </main>

      {/* Footer */}
       <Foot/>
    </>
  )
}

export default UserLayout